import { useRef, useState, useEffect } from "react";
import { Play, Pause, Download } from "lucide-react";

export default function WaveformPlayer({ src, downloadName = "cancion.wav" }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const bars = Array.from({ length: 40 });

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    const onTime = () => setProgress(a.duration ? a.currentTime / a.duration : 0);
    const onEnd = () => setPlaying(false);
    a.addEventListener("timeupdate", onTime);
    a.addEventListener("ended", onEnd);
    return () => { a.removeEventListener("timeupdate", onTime); a.removeEventListener("ended", onEnd); };
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); }
    else { a.play(); setPlaying(true); }
  };

  return (
    <div className="mfp-elev rounded-2xl p-4 flex items-center gap-4" data-testid="waveform-player">
      <audio ref={audioRef} src={src} preload="metadata" />
      <button data-testid="waveform-play-button" onClick={toggle}
        className="shrink-0 w-12 h-12 rounded-full bg-[#FF334B] hover:bg-[#E0223A] transition-colors flex items-center justify-center">
        {playing ? <Pause className="w-5 h-5 text-white" /> : <Play className="w-5 h-5 text-white ml-0.5" />}
      </button>
      <div className="flex-1 flex items-center gap-[3px] h-12 overflow-hidden">
        {bars.map((_, i) => {
          const active = i / bars.length <= progress;
          return (
            <div key={i}
              className={`flex-1 rounded-full ${playing ? "wave-bar" : ""}`}
              style={{
                height: `${20 + Math.abs(Math.sin(i * 0.9)) * 70}%`,
                background: active ? "var(--mfp-crimson)" : "rgba(255,255,255,0.14)",
                animationDelay: `${(i % 8) * 0.08}s`,
              }} />
          );
        })}
      </div>
      <a data-testid="waveform-download" href={src} download={downloadName}
        className="shrink-0 w-10 h-10 rounded-full border border-white/12 hover:border-[#FF334B] hover:text-[#FF334B] flex items-center justify-center transition-colors">
        <Download className="w-4 h-4" />
      </a>
    </div>
  );
}
